import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import { errorMessage } from "../../utils/alertMessage";
import { formatDateWithTime } from "../../constants/FormateDate";
import { getUserLead } from "../../services/leads";
import { getUserData } from "../../utils/localStorage";
import { DataScroller } from 'primereact/datascroller';
import { Button } from "primereact/button";

export default function UserLeadInfoList() {

  const { state } = useLocation();


  const rowData = state?.rowData || null;
  const products = state?.listState?.products || [];
  const first = state?.listState?.first || 0;
  const rows = state?.listState?.rows || 20;
  const selectedType = state?.listState?.selectedType || 'type1';
  const pagesBoxField = state?.listState?.pagesBoxField || 1;

  const [userLeadInfo, setUserLeadInfo] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  const ds = useRef(null);

  const [firstPage, setFirstPage] = useState(0);
  const [rowsPage, setRowsPage] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],
    leadIdIn: [rowData?.lead?.id]
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);

          if (append) {
            setUserLeadInfo((prev) => [...(prev || []), ...rawData]);
          } else {
            setUserLeadInfo(rawData);
          }
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };



  useEffect(() => {
    fetchData({
      ...typeData,
      limit: rowsPage,
      offset: 0
    });

  }, []);




  const loadMore = () => {
    const newOffset = firstPage + rowsPage;

    fetchData(
      {
        ...typeData,
        limit: rowsPage,
        offset: newOffset
      },
      true // append mode
    );

    setFirstPage(newOffset);
  };






  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">


                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <div >
                    <h5 className="card-title flex">
                      <div
                        className="mr-3 cursor-pointer"
                        onClick={() =>
                          navigate("/lead/list", {
                            state: {
                              listState: {
                                products,
                                first,
                                rows,
                                selectedType,
                                pagesBoxField
                              }
                            }
                          })
                        }
                      >
                        <i class="bi bi-arrow-left-circle-fill"></i>
                      </div>Lead User Working Status List
                    </h5>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row col-md-12">
                    <div className="col-md-4 mb-2">
                      <p className="text-lg" style={{
                        fontWeight: 600,
                        color: 'blue'
                      }}>Lead Status: {rowData?.lead?.status}</p>
                    </div>
                    <div className="col-md-4 mb-2">
                      <p className="text-md" style={{
                        fontWeight: 600,
                        color: 'green'
                      }}>Last Update on: {formatDateWithTime(rowData?.lead?.lastModifiedDate)}</p>
                    </div>
                  </div>


                </div>

                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={userLeadInfo}
                      // lazy
                      dataKey="id"
                      scrollable
                      scrollHeight="400px"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rowsPage}
                      rowsPerPageOptions={[rowsPage, rowsPage + 50, rowsPage + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design-without-btn"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>


                      <Column
                        field="name"
                        header="User Name"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.user?.userName}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="userRole"
                        header="User Role"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData.user?.role}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="createdOn"
                        header="Assigned On"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData?.createdDate)}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="LastModifyDate"
                        header="Last Modify On"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData?.lastModifiedDate)}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="status"
                        header="Working Status"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {(rowData?.status)}
                          </span>
                        )}
                      ></Column>


                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={userLeadInfo}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader
                  // footer={footer} 
                  // header="Click Load Button at Footer to Load More" 
                  />
                  <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>
                  {/*userLeadInfo && userLeadInfo.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
